module.exports = __webpack_public_path__ + "img/ic_favorite_curve.555605a9.svg";